import {
  DishDisclaimers,
  DishIngredient,
  TaxonomyDisclaimer,
  TaxonomyPreference,
} from "api-types";

export const groupIngredientsByDisclaimer = ({
  restaurantName,
  disclaimers,
  dishIngredients,
}: {
  restaurantName: string;
  disclaimers: TaxonomyDisclaimer[];
  dishIngredients: DishIngredient[];
}): DishDisclaimers[] => {
  return disclaimers.map((disclaimer) => {
    const ingredients = dishIngredients
      .filter((ingredient) => ingredient.disclaimerIds?.includes(disclaimer.id))
      .map((ingredient) => ({
        igfdTaxIngredientId: ingredient.igfdTaxIngredientId,
        name: ingredient.ingredientName,
      }));
    return {
      ...disclaimer,
      text: disclaimer.text.replace(/{{restaurant-name}}/g, restaurantName),
      ingredients,
    };
  });
};

export const calculatePreferenceDisclaimers = ({
  restaurantName,
  selectedPreference,
  disclaimers,
  dishIngredients,
}: {
  restaurantName: string;
  selectedPreference: TaxonomyPreference | null;
  disclaimers: TaxonomyDisclaimer[];
  dishIngredients: DishIngredient[];
}): DishDisclaimers[] => {
  if (
    !selectedPreference ||
    selectedPreference === null ||
    !disclaimers.length
  ) {
    return [];
  }

  const visibleDisclaimers: TaxonomyDisclaimer[] = [];
  const mayNotBeVeganDisclaimer = disclaimers.find(
    ({ id }) => id === "igfd:dis:maynotbevegan"
  );
  const mayNotBeVegetarianDisclaimer = disclaimers.find(
    ({ id }) => id === "igfd:dis:maynotbevegetarian"
  );
  const probioticsDisclaimer = disclaimers.find(
    ({ id }) => id === "igfd:dis:probiotics"
  );

  // For vegan we want to show an order of "may not be vegan" > "may not be vegetarian"
  if (selectedPreference.igfdTaxPreferenceId === "igfd:preference:vegan") {
    if (mayNotBeVeganDisclaimer) {
      visibleDisclaimers.push(mayNotBeVeganDisclaimer);
    } else if (mayNotBeVegetarianDisclaimer) {
      visibleDisclaimers.push(mayNotBeVegetarianDisclaimer);
    }
  }

  // For vegetarian we want to show if presence of "may not be vegetarian"
  if (
    selectedPreference.igfdTaxPreferenceId === "igfd:preference:vegetarian" &&
    mayNotBeVegetarianDisclaimer
  ) {
    visibleDisclaimers.push(mayNotBeVegetarianDisclaimer);
  }

  // Always include as last disclaimer if present
  if (probioticsDisclaimer) {
    visibleDisclaimers.push(probioticsDisclaimer);
  }

  return groupIngredientsByDisclaimer({
    restaurantName,
    disclaimers: visibleDisclaimers,
    dishIngredients,
  });
};
